import { apiClient } from '@/api/client'

export type LinkTargetType = 'memo' | 'product'

export type LinkCandidate = {
  target_type: LinkTargetType
  target_id: number
  title: string
  /** 読書ノートがあるか（作品のみ） */
  has_note: boolean
  /** カードか（メモのみ） */
  is_card: boolean
}

export type Backlink = {
  /** リンク元の本文の種別（memo / product_note / todo） */
  source_type: string
  source_id: number
  title: string
  preview: string
  updated_at: string
  /** link: [[ でリンク / highlight: この本のハイライトを引用 */
  via: 'link' | 'highlight'
}

/** [[ で挿入するリンク先の候補（メモ・作品） */
export const getLinkCandidates = async (q: string): Promise<LinkCandidate[]> => {
  const res = await apiClient.get<{ items: LinkCandidate[] }>('/links/candidates', { params: { q } })
  return res.data.items
}

/** メモ・作品にリンクしている本文 */
export const getBacklinks = async (targetType: LinkTargetType, targetId: number): Promise<Backlink[]> => {
  const res = await apiClient.get<{ items: Backlink[] }>('/links/backlinks', {
    params: { target_type: targetType, target_id: targetId },
  })
  return res.data.items
}

export type UnlinkedMention = {
  source_type: string
  source_id: number
  title: string
  /** タイトルが出てくる前後の文 */
  snippet: string
  updated_at: string
}

/** リンクせずにメモのタイトルを書いている本文 */
export const getUnlinkedMentions = async (memoId: number): Promise<UnlinkedMention[]> => {
  const res = await apiClient.get<{ items: UnlinkedMention[] }>('/links/unlinked-mentions', {
    params: { memo_id: memoId },
  })
  return res.data.items
}

export type GraphNodeType = 'card' | 'memo' | 'book' | 'todo'

export type GraphNode = {
  /** "memo:15" / "book:379208" / "todo:3" */
  id: string
  type: GraphNodeType
  ref_id: number
  title: string
}

export type GraphEdge = {
  source: string
  target: string
  /** link: [[ でリンク / cite: その本のハイライトを引用 */
  kind: 'link' | 'cite'
  weight: number
}

export type LinkGraph = {
  nodes: GraphNode[]
  edges: GraphEdge[]
}

/** メモ・本・カードとそのつながり */
export const getLinkGraph = async (): Promise<LinkGraph> => {
  const res = await apiClient.get<LinkGraph>('/links/graph')
  return res.data
}
